import React from 'react';
import '../style.scss';
import { EstablishHeader } from 'views/components/atoms/establishes/header';
import { EstablishCheck } from 'views/components/atoms/establishes/check';
import { EstablishError } from 'views/components/atoms/establishes/error';

export type InputConsentProps = {
  title: string;
  name: string;
  checkText: string;
  linkTitle?: string;
  linkUrl?: string;
  onClickLink?: () => void;
  isChecked: boolean;
  disabled?: boolean;
  setIsChecked: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isEnable: boolean;
  errorText?: string;
  batchDangerWord?: string;
};

export const InputConsent = (props: InputConsentProps) => {
  const {
    title,
    name,
    checkText,
    isChecked,
    disabled,
    setIsChecked,
    isEnable,
    errorText,
    batchDangerWord,
  } = props;
  return (
    <div className="inputWrapper">
      <EstablishHeader headerTitle={title} batchDangerWord={batchDangerWord} />
      <fieldset className={name}>
        <EstablishCheck
          name={name}
          text={checkText}
          isChecked={isChecked}
          disabled={disabled}
          setIsChecked={setIsChecked}
        />
      </fieldset>
      <EstablishError isEnabled={isEnable} errorText={errorText} />
    </div>
  );
};
